var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { SHARED_Z_INDEX, Types } from './constants';
import styled, { css } from 'styled-components';

var getDisplayState = function getDisplayState(props) {
  if (props.isVisible) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      opacity: 0.75;\n      pointer-events: initial;\n    "])));
  }

  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    opacity: 0;\n    pointer-events: none;\n  "])));
};

var getBackgroundForKind = function getBackgroundForKind(props) {
  switch (props.kind) {
    case Types.Transparent:
      return 'transparent';

    case Types.Light:
    case Types.Loading:
      return props.themeColors.OverlayBackgroundLoading;

    case Types.Dark:
    default:
      return props.themeColors.OverlayBackgroundDefault;
  }
};

var getTransition = function getTransition(props) {
  if (props.isAnimated) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      transition: 0.3s ease-in-out all;\n    "])));
  }

  return null;
};

export var OverlayContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: ", ";\n"])), SHARED_Z_INDEX);
export var OverlayLayer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: ", ";\n  background-color: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  ", "\n  ", "\n"])), SHARED_Z_INDEX, getBackgroundForKind, getDisplayState, getTransition);
export var OverlayContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
export var ContentContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  margin: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));